module.exports = __webpack_public_path__ + "static/Profile1-7abc103b466d4a03e523545fc1e151d7.jpg";